import Cookies from "js-cookie";

/**
 * Last known account state of the navbar, so a returning user sees the same
 * navbar they left with instead of an empty placeholder while `me` is in flight.
 * Deliberately holds no personal data — only what the navbar needs to decide
 * between the login button, the premium button and the logged-in controls.
 */
export const NAVBAR_ACCOUNT_STATE_COOKIE = "exp_navbar_account_state";

export type NavbarAccountState = "guest" | "basic" | "premium";

export interface NavbarAccountFlags {
  isLoggedIn: boolean;
  isPremium: boolean;
}

// matches the session cookie lifetime (iron-session default ttl, 14 days),
// so the hint never outlives the session it describes
const EXPIRES_IN_DAYS = 14;

export function toNavbarAccountState({
  isLoggedIn,
  isPremium,
}: NavbarAccountFlags): NavbarAccountState {
  if (!isLoggedIn) return "guest";

  return isPremium ? "premium" : "basic";
}

export function parseNavbarAccountState(
  value?: string | null
): NavbarAccountFlags | null {
  switch (value) {
    case "guest":
      return { isLoggedIn: false, isPremium: false };
    case "basic":
      return { isLoggedIn: true, isPremium: false };
    case "premium":
      return { isLoggedIn: true, isPremium: true };
    default:
      return null;
  }
}

export function writeNavbarAccountStateCookie(flags: NavbarAccountFlags) {
  Cookies.set(NAVBAR_ACCOUNT_STATE_COOKIE, toNavbarAccountState(flags), {
    expires: EXPIRES_IN_DAYS,
    sameSite: "lax",
    secure: window.location.protocol === "https:",
  });
}
